<template>
  <div class="top-container" >

     <img class="image" src="@/assets/avatar-default.png" alt="">
     <div class="text-container">
       <p class="title">Sean Mallen - 1 day ago</p>

       <p class="text">ptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."</p>

       <div v-if="isReplay" class="comment-input-container">
         <text-area rows="2" v-model="comment" />
         <div class="button-container">
           <button @click="isReplayClose" class="button is-text">CANCEL</button>
           <button class="button is-primary">REPLAY</button>
         </div>
       </div>

       <div v-else class="reply-button" @click="isReplayActive">Reply</div>

     </div>
  </div>
</template>

<script>
import TextArea from '../../general/text-area.vue'

export default {
  name: 'Comment',
  components: {
    TextArea
  },
  data () {
    return {
      isReplay: false,
      comment: ''
    }
  },
  computed: {
  },
  methods: {
    isReplayActive () {
      this.isReplay = true
    },
    isReplayClose () {
      this.isReplay = false
    }
  },
  async mounted () {
  },
  beforeDestroy () {
  }
}
</script>

<style lang="scss" scoped>
.top-container{
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-top: 18px;
}

.text-container{
  padding-top: 12px;
}
.title{
  color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.text{
  color: #000;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.reply-button{
  margin-top: 10px;
  color: #31E5FF;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  cursor: pointer;
}

.image{
  height: 50px;
  width: 50px;
  border-radius: 50%;
}
.comment-input-container{
  margin-top: 10px;
}

.button-container{
  display: flex;
  justify-content: end;
  gap: 10px;
}

@media (max-width: 760px) {
  .title{
    font-size: 14px;
  }
  .image{
    height: 40px;
    width: 40px;
    border-radius: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dao-community/proposal/comment.vue